import { render, staticRenderFns } from "./electronicInvoice.vue?vue&type=template&id=e0651170&scoped=true&"
import script from "./electronicInvoice.vue?vue&type=script&lang=js&"
export * from "./electronicInvoice.vue?vue&type=script&lang=js&"
import style0 from "./electronicInvoice.vue?vue&type=style&index=0&id=e0651170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0651170",
  null
  
)

export default component.exports